<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M22.5 5V4a1 1 0 00-2 0v1H17V4a1 1 0 00-2 0v1h-3.5V4a1 1 0 00-2 0v1H5a2 2 0 00-2 2v20a2 2 0 002 2h22a2 2 0 002-2V7a2 2 0 00-2-2zm-13 2v1a1 1 0 002 0V7H15v1a1 1 0 002 0V7h3.5v1a1 1 0 002 0V7H27v5.18H5V7zM5 27V14.18h22V27z"/></svg>